import { AvailabilitiesResponse } from "@/types/responses"

const isHaveAvailability = (avail_resp: AvailabilitiesResponse | null): boolean => {
    if (!avail_resp || Object.keys(avail_resp).length === 0 || !avail_resp?.endDates || !avail_resp?.endDates?.startDate || avail_resp?.prestations?.length === 0) {
        return false

    }
    return true
}

export default isHaveAvailability